import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CustomAuthModule } from '@innobile/authmodule';
import { environment } from '../environments/environment';
import { LaundryUser } from './laundry-user';
import { LaundriesInterceptor } from './laundries.interceptor';
import { SharedVariablesService } from './shared/shared-variables.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      CustomAuthModule.forRoot({
        config: {
          apiPrefix: environment.apiPrefix,
          userModel: LaundryUser,
          loginEndpoint: 'v1/authenticate',
          whitelistedApiCalls: ['v1/authenticate'],
          userInfoEndpoint: 'v1/userinfo',
        },
      })
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LaundriesInterceptor,
      multi: true,
    },
    SharedVariablesService,
  ],
};
